import {Component, Input} from '@angular/core';
import {AlertController, Events, NavController, NavParams, PopoverController} from "ionic-angular";
import {HttpClient} from "@angular/common/http";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";
import {CompleteBookingModalPage} from "../../pages/complete-booking-modal/complete-booking-modal";
import {DurationPipe} from "../../pipes/duration/duration";
import moment from "moment";
import {InAppBrowserOptions} from "@ionic-native/in-app-browser";
import {BookingServiceProvider} from "../../providers/booking-service/booking-service";

/**
 * Generated class for the StaffCurrentQueueComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'staff-current-queue',
    templateUrl: 'staff-current-queue.html'
})
export class StaffCurrentQueueComponent {
    @Input() barber: any;
    @Input() currencySymbol: any;

    errors: {};
    loading: boolean;
    bookingsToggle: boolean;
    activeBooking: any;

    constructor(
        public navCtrl: NavController,
        public  navParams: NavParams,
        public events: Events,
        private http: HttpClient,
        private apiErrorHandler: ApiErrorHandlerProvider,
        public durationPipe: DurationPipe,
        private alertCtrl: AlertController,
        private popoverCtrl: PopoverController,
        public  bookingService: BookingServiceProvider
    ) {
    }

    ngOnInit() {
        this.setActiveBooking();
        // Track todays booking service name
        if (this.barber && this.barber.todays_bookings.length) { 
            this.barber.todays_bookings[0].services = this.bookingService.assignServices(this.barber); 
        }
    }

    toggleBookings(event) {
            return new Promise((resolve, reject) => {
                this.http.post(`/staff/pauseBookings`, {
                    pause: event.value,
                    user: this.barber
                }).subscribe(res => {
                    this.errors = {};
                    this.loading = false;
                    resolve(true)
                }, error => {
                    this.loading = false;
                    this.errors = this.apiErrorHandler.handleError(error);
                    reject(this.errors)
                })
            });
    }

    barberHasAdvancedBookingHoursForToday(barber) {
      //@todo in /v3/ of the api, return an object and do a check as follows
      // if (barber.hasOwnProperty('advanced_booking_hours') && barber.advanced_booking_hours)
        if (barber.advanced_booking_hours && barber.advanced_booking_hours[0]) {
            let dayOfWeek = moment(new Date()).format('dddd').toLowerCase();
            if (barber.advanced_booking_hours[0][dayOfWeek]) {
                return true;
            }
        }
        return false;
    }

    confirmBookingCompletion(booking) {
        let bookingCompletionModal = this.popoverCtrl.create(CompleteBookingModalPage,
            {
                booking: booking,
                barber: this.barber
            },
            {
                cssClass: 'complete-booking-modal',
                enableBackdropDismiss: false
            });

        bookingCompletionModal.present();

        // Add the completed booking to the completed bookings array
        bookingCompletionModal.onDidDismiss((res) => {
            if (res && (res.id === booking.id)) {
                this.barber.todays_completed_bookings.push(booking);
                this.barber.todays_bookings.splice(0, 1);

                this.events.publish('myChair:badge');
            }
        })
    }

    ngOnChanges(changes) {
        if (changes.barber) {
            this.barber = changes.barber.currentValue;
            this.setActiveBooking();

            this.events.publish('myChair:badge');
        }
    }

    setActiveBooking() {
        this.activeBooking = this.barber.todays_bookings[0];


        this.bookingsToggle = this.barber.queue_status ? false : true;

        if (this.activeBooking) {
            this.activeBooking.completesIn = parseInt(this.activeBooking.totalLength) + parseInt(this.activeBooking.booking.estimated_wait_time_in_minutes);
        }
    }

    parseNumber(number){
      return Number(number);
    }
}



// WEBPACK FOOTER //
// ./src/components/staff-current-queue/staff-current-queue.ts